<template>
  <div class="flex items-center" style="padding-top:20px;">
    <vs-chip class="ag-grid-cell-chip"  v-for="(item,index) in values" :key="index" :color="chipColor(item.value)">
      <span >{{item.web}}</span>
    </vs-chip>
  </div>
</template>
<script>
const axios = require('axios').default;
import firebase from '@/services/saleData';
import 'firebase/database';
export default {
  name: 'CellRendererWeb',
  data () {
    return {
      values:[],
      value:[],
    }
  },
  mounted () {
    const array = this.params.data.web
    const values = [];
    setTimeout(() => {
      for(const x in this.sites){
        let check = '';
        if(array[x] && array[x].status){
          check = true;
        }else if(array[x] && array[x].status===false){
          check = false;
        }else{
           check = 'error';
        }
        values.push({
          value:check,
          web:(x.charAt(0).toUpperCase() === 'L')?'A':x.charAt(0).toUpperCase(),
          key:x
        });
      }
      this.values = values;
    }, 1000);
  },
  computed: {
    sites () {
      return this.$store.state.userManagement.sites
    },
    chipColor () {
      return (value) => {
        if (value === true) return 'success'
        if (value === false) return 'danger';
        return '#CCCCCC';
      }
    }
  },
  methods: {
    recreateUser (value) {
      if(value.value === 'error'){
      this.value = value;
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm create user',
        text: `You are about to create "${this.params.data.firstname} ${this.params.data.lastname} on ${value.key}"`,
        accept: this.confirmRecreateUser,
        acceptText: 'Sure'
      })
      }else if(value.value){
        this.value = value;
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirm disable user',
          text: `You are about to disable "${this.params.data.firstname} ${this.params.data.lastname} on ${value.key}"`,
          accept: this.confirmDisableUser,
          acceptText: 'Sure'
        })
      }else if(!value.value){
        this.value = value;
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: 'Confirm enable user',
          text: `You are about to enable "${this.params.data.firstname} ${this.params.data.lastname} on ${value.key}"`,
          accept: this.confirmEnableUser,
          acceptText: 'Sure'
        })
      }
    },
    confirmRecreateUser(){
      if(this.params.data.key && this.value.key){
        axios({
          method: "get",
          url: "https://api.xxmac.co/api/createuser/"+this.params.data.key+'/'+this.value.key,
        }).then(async response => {
          if (response.data && response.data.status) {
            //this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
          }
        });
      }
    },
    confirmDisableUser(){
      if(this.params.data.key && this.value.key){
        firebase.database().ref(`users/${this.params.data.key}/web/${this.value.key}`).update({
          status:false
        });
      }
    },
    confirmEnableUser(){
      if(this.params.data.key && this.value.key){
        firebase.database().ref(`users/${this.params.data.key}/web/${this.value.key}`).update({
          status:true
        });
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}
</style>
